/**
 * Type Guards and Type Utilities
 *
 * Type-safe helpers for narrowing and validating types
 * Eliminates unnecessary type conversions and improves type safety
 */

import type { PickemQuestion } from '@low6-pickem/api-types';

/**
 * Type guard to check if a question is a team pick question
 */
export function isTeamQuestion(question: PickemQuestion): boolean {
  return question.question_type === 'team' || question.question_type === 'TEAM_PICK';
}

/**
 * Type guard to check if a question is a tiebreaker question
 */
export function isTiebreakerQuestion(question: PickemQuestion): boolean {
  return question.is_tiebreak === true || question.question_type === 'tiebreaker';
}

/**
 * Safely convert a question_id to string
 * Handles both string and number types from API
 */
export function toQuestionId(id: string | number | undefined | null): string {
  if (id === undefined || id === null) return '';
  return String(id);
}
